import { useState } from 'react';
import { svgSprite, Tooltip } from '../../../../hybrid/wrappers';
import css from './CalendarFilterButton.module.scss';
import Filter from './components/Filter/Filter';
import classNames from 'classnames';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import MobileFilter from './components/MobileFilter/MobileFilter';
import T from '../../../../common/components/T';

export default function CalendarFilterButton({
    url,
    attributes,
    setData,
    initValue,
    additionalButtons = [],
    showMobileFilterWidth = 992,
    customClasses = {},
    filterTrigger,
    resetFilterParams = ''
}) {
    const [filter, showFilter] = useState(false);
    const [mobileFilter, showMobileFilter] = useState(false);
    const width = useWindowDimensions();
    const isMobileFilter = width < showMobileFilterWidth && additionalButtons?.length;

    const buttonHandler = () => {
        if (isMobileFilter) {
            if (filter) {
                showFilter(false);
            }
            showMobileFilter((s) => !s);
        } else {
            showFilter((s) => !s);
        }
    };

    const isMobile = useWindowDimensions() < 768;
    return (
        <>
            <Tooltip
                showModalTooltip={!isMobile}
                text={<T textName='specify_marketing_period' defaultStr='Указать маркетинговый период' page='/office' />}
            >
                <div className={css.buttonWrapper}>
                    <div onClick={buttonHandler} className={classNames(css.button, customClasses.button, 'circleButton')}>
                        {svgSprite(isMobileFilter ? 'dots' : 'calendar-icon-filled-new', {
                            className: classNames(css.buttonSvg, { [css.buttonSvgActive]: filter })
                        })}
                    </div>
                    {filter ? (
                        <Filter
                            closeHandler={() => showFilter(false)}
                            attributes={attributes}
                            url={url}
                            setData={setData}
                            initValue={initValue}
                            filterTrigger={filterTrigger}
                            resetFilterParams={resetFilterParams}
                        />
                    ) : null}
                    {mobileFilter ? (
                        <MobileFilter
                            closeHandler={() => showMobileFilter(false)}
                            buttons={[
                                {
                                    name: (
                                        <T
                                            textName='specify_marketing_period'
                                            defaultStr='Указать маркетинговый период'
                                            page='/office'
                                        />
                                    ),
                                    func: () => showFilter((s) => !s)
                                },
                                ...(additionalButtons && Array.isArray(additionalButtons) && additionalButtons?.length
                                    ? additionalButtons.map((button) => ({
                                          name: button.mobileName,
                                          func: button.mobileFunc
                                      }))
                                    : [])
                            ]}
                        />
                    ) : null}
                </div>
            </Tooltip>
            {!isMobileFilter && additionalButtons && Array.isArray(additionalButtons) && additionalButtons?.length
                ? additionalButtons.map((button) => button.component)
                : null}
        </>
    );
}
